const FormSection = (props: any) =>
    <div className={`form-section ${props.divider ? 'form-section-divider' : ''}`} data-label={props.dividerLabel}>{props.children}</div>;

export default FormSection;
